import type { CodeableConcept } from '@medplum/fhirtypes'
import { CodeableConceptDisplay } from '@medplum/react'
import { castArray } from 'lodash-es'
import type { JSX } from 'react'
import { extractTextFromHTML } from '#src/utils/html.ts'

interface CodeableConceptsDisplayProps {
  codeableConcepts: CodeableConcept | CodeableConcept[] | undefined
}

export function CodeableConceptsDisplay({
  codeableConcepts,
}: CodeableConceptsDisplayProps): JSX.Element | null {
  if (!codeableConcepts) {
    return null
  }

  const concepts = castArray(codeableConcepts).map((concept) => ({
    ...concept,
    text: extractTextFromHTML(concept.text ?? ''),
  }))

  if (concepts.length === 0) {
    return null
  }

  return (
    <div className="text-sm">
      {concepts.length === 1 ? (
        <CodeableConceptDisplay value={concepts[0]} />
      ) : (
        concepts.map((concept, i) => (
          <div key={i}>
            <CodeableConceptDisplay value={concept} />
          </div>
        ))
      )}
    </div>
  )
}
